import { localAppStore } from './local';

export const appStore = localAppStore;
